import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CurrentCalendarQuery } from '../types';
import { GpCalendarItemInputSchema } from 'appsync';
import { z } from 'zod';

/**
 * typeguard for CurrentCalendarQuery
 * @param CurrentCalendarQuery object passed to transformer
 */
export const isValidCurrentCalendar = (obj: CurrentCalendarQuery): boolean => Boolean(obj?.data?.getGpCurrentCalendarWidget && !isEmptyObject(obj.data.getGpCurrentCalendarWidget));


export function CreateGpCurrentCalendarWidgetInputSchema() {
  return z.object({
    items: z.array(z.lazy(() => GpCalendarItemInputSchema().nullable())).nullish(),
  });
}